import API from '../api'
import getUrl from './paths'

export const getAdminPastRecords = (orgIds = []) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAdminPastRecords, { orgIds: (Array.isArray(orgIds) ? orgIds : [orgIds]).join(',') })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
